import React, { useState } from "react";
import { generatePostmanCollection } from "../../utils/postman-generator";
import styles from "./WorkflowModal.module.scss";
import Stepper from "./Stepper";
import CodeSnippet from "../../../ApiReference/LocalComponents/CodeSnippet";

const WorkflowModal = ({ workflow, icon, onClose }) => {
  const [activeStep, setActiveStep] = useState(0);

  const handleStepClick = (index) => {
    setActiveStep(index);
  };

  const handleDownload = () => {
    const collection = generatePostmanCollection(workflow);
    const blob = new Blob([JSON.stringify(collection, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${workflow.displayText}.postman_collection.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const combinedCode = workflow.list.contentItems
    .map((step, index) => {
      const code = `# ${step.stepTitle}\n${step.codeSnippet}`;
      if (index === activeStep) {
        return `__HIGHLIGHT_START__${code}__HIGHLIGHT_END__`;
      }
      return code;
    })
    .join("\n\n");

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <span className={`material-icons ${styles.modalIcon}`}>{icon}</span>
          <div className={styles.titleSection}>
            <div className={styles.titleLine}>
              <h2>{workflow.displayText}</h2>
              <button
                className={styles.downloadButton}
                onClick={handleDownload}
                title="Download Postman Collection"
              >
                <span className="material-icons">download</span>
                Download Postman
              </button>
            </div>
            <p className={styles.description}>{workflow.description}</p>
          </div>
          <button className={styles.closeButton} onClick={onClose}>
            <span className={`material-icons ${styles.closeIcon}`}>close</span>
          </button>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.stepperContainer}>
            <Stepper
              steps={workflow.list.contentItems}
              activeStep={activeStep}
              onStepClick={handleStepClick}
            />
          </div>
          <div className={styles.codeContainer}>
            <CodeSnippet language="curl" examples={{ curl: combinedCode }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkflowModal;